<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-select
                    :options="form.tipos"
                    :validations="validations.tipo"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.tipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.cnpj"
                    label="CNPJ"
                    placeholder="99.999.999/9999-99"
                    uppercase
                    v-mask="mask.cnpj"
                    v-model="model.cnpj"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, mask, unmask } from '@/mixins'

// Enums.
import fabricanteTipo from '@/enums/cadastro/fabricante/fabricanteTipo'

export default {
    computed: {
        validations() {

            return {
                tipo: {
                    required: true
                },
                nome: {
                    required: true,
                    max: 180,
                },
                cnpj: {
                    required: this.model.tipoId == this.enums.fabricanteTipo.NACIONAL,
                    min_max_without_mask: 14,
                    cnpj: true,
                },
            }
        },
    },
    created() {

        this.repositories = {
            fabricante: this.getConectaSusRepository('cadastro.fabricante'),
        }

        this.load()
    },
    data: () => ({
        form: null,
        model: null,
        enums: { fabricanteTipo },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            if (this.id) {

                this.repositories.fabricante.edit(this.id)
                    .then(({ data }) => {

                        this.form = this.clone(data.form)

                        if (data.model) {

                            this.model = this.clone(data.model)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {

                this.repositories.fabricante.create()
                    .then(({ data }) => {

                        this.form = this.clone(data.form)

                        if (data.model) {

                            this.model = this.clone(data.model)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.fabricante.update(this.id, this.prepareData())
                        : this.repositories.fabricante.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const model = this.clone(this.model)

            delete model.id

            if (model.cnpj) {

                model.cnpj = this.unMaskCnpj(model.cnpj)
            }

            return this.camelObjectKeysToSnakeRecursive(model)
        },
    },
    mixins: [ repository, stringCase, object, error, mask, unmask ],
    props: {
        id: { type: Number },
    },
}
</script>